import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'AreAllYSelected',
})
export class AreAllYSelectedPipe implements PipeTransform {
  transform(
    allSelectedByX: string[],
    x: string
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ) {
    return allSelectedByX.includes(x);
  }
}
